<script>

import {defineComponent} from "vue";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import axios from "axios";
import {RAW_MATERIAL_PATH} from "@/path";
import Swal from "sweetalert2";

export default defineComponent({
  props : ['selectedRawMaterial'],
  components: {SelectWithSearch},
  data(){
    return {
      cdn : process.env.VUE_APP_AWS_CDN,
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      form : {
        unit_convertions : []
      },
      categoryOptions : ['Fresh Vegitables','Grocery','Egg','Dairy','Poultry','Semi Finished Product','Mutton'],
    }
  },
  watch : {
    selectedRawMaterial(v){
      this.form = v;
    }
  },
  mounted(){
    if(this.selectedRawMaterial){
      this.form = this.selectedRawMaterial;
    }
  },
  methods : {
    async saveRawMaterial(){
      try {
        let res = await axios.post(this.baseUrl + RAW_MATERIAL_PATH.SAVE,this.form);
        if(res.data.status){
          Swal.fire("success",'','success');
          this.$bvModal.hide('bv-add-raw-material')
          this.$emit('update');
        }
      }catch (e){
        console.log(e);
      }
    },
    addConvertion(){
      if(!this.form.unit_convertions){
        this.form.unit_convertions = [];
      }else if(this.form.unit_convertions == null){
        this.form.unit_convertions = [];
      }
      this.form.unit_convertions.push({
        from_unit : null,
        to_unit : null,
        convertion : null
      });     
    }
  }
})
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col class="mt-3" sm="12">
          <label>Name</label>
          <b-form-input size="sm" v-model="form.name"></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="12">
          <label>Category</label>
          <b-select size="sm" :options="categoryOptions" v-model="form.category"></b-select>
        </b-col>
        <b-col class="mt-3" sm="12">
          <label>Description</label>
          <b-textarea size="sm" v-model="form.description"></b-textarea>
        </b-col>
        <b-col class="mt-3" sm="12">
          <label>Uom</label>
          <b-select v-model="form.uom" :options="['kg','gm','ltr','ml','pcs']"></b-select>
        </b-col>
        <b-col sm="12">
          <label>Unit Convertions <b-button variant="primary" size="sm" @click="addConvertion()"><i class="fa fa-plus"></i></b-button></label>
          <b-row v-for="(f,fi) in form.unit_convertions" :key="fi">
            <b-col sm="4">
              <label>From Unit</label>
              <b-select v-model="f.from_unit" :options="['kg','gm','ltr','ml']"></b-select>
            </b-col>
            <b-col sm="3">
              <label>Convertion Value (per 1 unit)</label>
              <b-input v-model="f.convertion"></b-input>
            </b-col>
            <b-col sm="3">
              <label>To Unit</label>
              <b-select v-model="f.to_unit" :options="['kg','gm','ltr','ml','pcs']"></b-select>
            </b-col>            
            <b-col sm="2">
              <b-button class="mt-4" variant="danger" size="sm" @click="(() => form.unit_convertions.splice(fi,1))"><i class="fa fa-trash"></i></b-button>
            </b-col>
        </b-row>
        </b-col>        
        <b-col class="mt-3" size="sm">
          <b-button @click="saveRawMaterial" variant="primary">Save</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style>

</style>